import {Component, Input} from '@angular/core';
import {NgIf} from "@angular/common";
import {constGridPaginatorOption} from "../../utils/constant";

@Component({
  selector: 'no-records-found',
  standalone: true,
  imports: [NgIf],
  template: `
      <table class="w-full text-center h-full border-b">
          <tr>
              <td>
                  <img [src]="'assets/layout/images/pages/NoRecordFound.jpg'" class="h-15rem" alt="">
                  <div class="text-lg text-gray-500 font-medium">{{ displayText }}</div>
              </td>
          </tr>
      </table>
  `,
})
export class NoRecordsFoundComponent {
  @Input() displayText: string = constGridPaginatorOption.noRecordsMsg;
}
